<template>
  <div style="display: flex;justify-content: center;">
    <b-card
      no-body
      class="overflow-hidden card-item card-feature"
      v-if="isCardFeature"
    >
     
      <div class="content">
        <b-img class="logo-app-brand" src="/images/group394.jpg" :alt="$t('Advertise with us Buy-Sell')"/>
      </div>
      <div class="content-item">{{$t('Buyers may be looking for your product is')}}</div>
      <b-button id="gotoFAQ" @click="gotoFAQ" class="btn-button " variant="primary"
        >{{$t('advertise now')}}!</b-button>
    </b-card>

    <b-card
      no-body
      class="card-item overflow-hidden"
      style="width:250px;height:250px"
      v-else-if="showGoogleAds && adsCard && !adsCard.advertisment_location.google_on"
    >
      <a
        :href="adsCard.website"
        target="_blank"
        v-if="!adsCard.advertisment_location.google_on"
        id="updateBannerHit"
        @click="updateBannerHit(adsCard)"
      >
        <b-card-img :src="adsCard.image" :alt="adsCard.website?adsCard.website:$t('Advertise with us Buy-Sell')" class="img-card"></b-card-img>
      </a>
       
    </b-card>
    <div style="width:250px;height:250px" 
        v-else-if="showGoogleAds && adsCard && adsCard.advertisment_location.google_on"><!-- 250x250 -->
          <Adsense
            data-ad-test="false"
            in-style="display:inline-block;width:250px;height:250px"
            :data-ad-client="$root.googleClientId"
            :data-ad-slot="adsCard.advertisment_location.google_ad_key"
            data-ad-format="rectangle"
          >
          </Adsense>
    </div>

    <b-card
      no-body
      class="overflow-hidden card-item"
      :class="{'mobile-card':$router.history.current.path == '/th'||
      $router.history.current.path == '/en'||
      $router.history.current.path == '/th/'||
      $router.history.current.path == '/en/'||$router.history.current.name == 'SellerDetail'||$router.history.current.name == 'ListingDetail'}"
      v-else
    >
      <b-row no-gutters>
        <router-link
          id="listingDetail"
          :to="$i18nRoute({ name: 'listing-detail' }, id)"
        >
          <b-col md="12" style="position: relative;padding:0;">
              <b-card-img :alt="title?title:$t('Advertise with us Buy-Sell')" :src="urlImage.replace('832x468', '250x141')" class="img-card image" v-if="urlImage"></b-card-img>
              <b-card-img :alt="title?title:$t('Advertise with us Buy-Sell')" :src="urlImage" class="img-card image" v-if="!urlImage"></b-card-img>
              <div class="soldRented" v-if="status==5">
                  {{$t('Sold')}}
              </div>
              <div class="soldRented" v-if="status==4">
                  {{$t('rented')}}
              </div>
            <div v-if="isQuickSale" class="hot">
              <div>{{ $t("packages.quickSale.title") }}</div>
            </div>
            <div v-if="isFeature" class="bookmark">
              <div class="start-while">
                <StarIcon />
              </div>
            </div>
            
          </b-col>
        </router-link>
        <b-col md="12">
          
          <div class="agency-logo" v-if="agency_profile_image"
                :style="{ backgroundImage: 'url(' + agency_profile_image + ')' }"
              ></div>
          <b-card-body
            :class="{ 'bg-yellow': isHighlight, 'bg-light-green': isFeature }"
          >
            <b-card-text
              class="card-address"
              v-bind:class="{ 'card-negotiable-exists': isNegotiable }"
              v-if="province || district"
            >
              {{province? province : ''}} <IconArrowRight v-if="district" style="width: 16px;"/> {{ district?district:'' }}
            </b-card-text>
            <b-card-text class="card-info">
              <router-link
                id="listingDetail"
                :to="$i18nRoute({ name: 'listing-detail' }, id)"
              >
                {{ title.length>40?title.substring(0, 40)+'...':title }}
              </router-link>
            </b-card-text>
            <!--job category-->
            <b-card-text class="card-cost">
               {{price? price.toLocaleString("th-TH") :$t('caption.uponRequest') }} {{ price? $t('baht'):'' }}
            </b-card-text>
            <!--job category-->
            <b-card-text class="card-cost" v-if="salaryType">
              {{ salaryType }}
            </b-card-text>
            <b-card-text @click="favorite" class="card-favorite" v-if="showFav">
              <IconFavoriteBorder v-if="!isFavorite" />
              <FavoriteIcon v-else />
            </b-card-text>
            <b-card-text v-if="isNegotiable" class="card-negotiable">
              <div class="negotiable">
                {{ $t("packages.negotiable.title") }}
              </div>
            </b-card-text>
          </b-card-body>
        </b-col>
      </b-row>
    </b-card>
    <b-toast id="favourite-toast" variant="warning" solid ref="favourite-toast">
      <template v-slot:toast-title>
        <div class="d-flex flex-grow-1 align-items-baseline">
          <b-img
            blank
            blank-color="#dc3545"
            class="mr-2"
            width="12"
            height="12"
            :alt="$t('Advertise with us Buy-Sell')"
          ></b-img>
          <strong class="mr-auto">{{ $t("favourite.title") }}</strong>
        </div>
      </template>
      {{ $t("favourite.errLogin") }}
    </b-toast>
  </div>
</template>

<script>
import IconFavoriteBorder from "vue-material-design-icons/HeartOutline.vue";
import StarIcon from "vue-material-design-icons/Star.vue";
import FavoriteIcon from "vue-material-design-icons/Heart.vue";
import IconArrowRight from "@/components/icons/IconArrowRight/index"
import { mapActions, mapGetters } from "vuex";
import _ from "lodash";
export default {
  name: "Card",
  components: {
    IconFavoriteBorder,
    StarIcon,
    FavoriteIcon,
    IconArrowRight
  },
  props: {
    isHot: {
      type: Boolean,
      default: false
    },
    isBookmark: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: ""
    },
    showNegotiable: {
      type: Boolean,
      default: false
    },
    showGoogleAds: {
      type: Boolean,
      default: false
    },
    price: {
      type: Number,
      default: 0
    },
    province: {
      type: String,
      default: ""
    },
    district: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    urlImage: {
      type: String,
      default: "/images/card1.png"
    },
    agency_profile_image: {
      type: String,
    },
    id: {
      type: Number,
      default: 0
    },
    listingPremium: {
      type: Array,
      default: () => []
    },
    listing_attributes_details: {
      type: Array,
      default: () => []
    },
    isCardFeature: {
      type: Boolean,
      default: false
    },
    typeAds: {
      type: String,
      default: ""
    },
    fav: {
      type: Boolean,
      default: false
    },
    showFav: {
      type: Boolean,
      default: true
    },
    status: {
      type: Number,
      default: 1
    },
    url: {
      type: String,
      default: null
    },
    target: {
      type: String,
      default: '_self'
    }
  },
  data() {
    return {
      isFavorite: false,
      isQuickSale: false,
      isNegotiable: false,
      isFeature: false,
      isHighlight: false,
      itemFavourite: null,
      adsCard: {
        website: null,
        image: "",
        advertisment_location: {
          google_on: false
        }
      },
      idTypeAds: {
        feature: 4,
        marketPlace: 5,
        realEstate: 6,
        cars: 7,
        jobs: 8,
        search: 9
      },
      locationIdForCardAds: 0,
      minSalary:0,
      salaryType:null
    };
  },
  watch: {
    // fav:function(val){
    //     this.isFavorite=val
    // },
    listingPremium: function(val) {
      this.checkPackage(val);
    },
    typeAds: function(val) {},
    showGoogleAds: function(val) {
      this.processAdsCreation();
    },
    
  },
  mounted() {
    this.checkPackage(this.listingPremium);
    
  },
  created() {
    //this.checkPackage(this.listingPremium)
    if(this.id){
      this.isFavorite=this.fav;  
    }
    this.processAdsCreation();
    
  },
  methods: {
    ...mapActions("AdsController", [
      "GETADS_FOR_PUBLIC_WEBSITE",
      "CLICK_BANNERADS"
    ]),

    ...mapActions("FavouriteController", [
      "CREATE_FAVOURITES_USER",
      "DELETE_FAVOURITES_USER"
    ]),
   
    updateBannerHit(item) {
      if (item.id) {
        this.CLICK_BANNERADS(item.id);
      }
    },
    createFavourites() {
      if (this.$root.isAuthenticated && this.id) {
        this.CREATE_FAVOURITES_USER({
          listing_id: this.id
        });
      }
    },
    deleteFavourites() {
      if (this.$root.isAuthenticated ) {
        this.DELETE_FAVOURITES_USER({
          id: this.id
        });
      }
    },
    favorite() {
      if (!this.$root.isAuthenticated) return this.$refs["favourite-toast"].show();
      
      this.isFavorite=!this.isFavorite;
      if (this.isFavorite) {
        this.createFavourites();
      } else {
        this.deleteFavourites();
      }
    },

    async checkPackage(val) {
      this.isHighlight = false;
      this.isFeature = false;
      this.isQuickSale = false;
      this.isNegotiable = false;
      return await Promise.all(
        await val.map(data => {
          if (data.package_id == 1) {
            this.isHighlight = true;
            this.isFeature = true;
          }
          if (data.package_id == 3) {
            this.isQuickSale = true;
          }
          if (data.package_id == 4) {
            this.isNegotiable = true;
          }
          if (data.package_id == 5) {
            this.isHighlight = true;
          }
        })
      );
    },
    gotoFAQ() {
      // this.$store.dispatch("FavouriteController/GET_FAQ",true);
      // this.$router.push(this.$i18nRoute({ name: 'faq'})+'#frequently-asked-questions')
      // this.$emit("gotoLogin");
       if (!this.$root.isAuthenticated) {
        this.openKhaosodLogin();
      } else {
        this.$router.push(this.$i18nRoute({ name: "add-listing" }));
      }
    },
    getAds(locationId) {

      this.GETADS_FOR_PUBLIC_WEBSITE({ id: locationId })
        .then(({ data }) => {
          
          if (data) {
            this.adsCard = data;
          }
        })
        .catch(err => {
          
        });
    },
    processAdsCreation() {
      let locationIdForCardAds = 11;
      if (
        (this.$router.history.current.path == "/th" ||
          this.$router.history.current.path == "/en") &&
        this.typeAds == "residential"||
        this.typeAds == "marketPlace"
      ) {
        locationIdForCardAds = 5;
      }
      if (
        (this.$router.history.current.path == "/th" ||
          this.$router.history.current.path == "/en") &&
        this.typeAds == "commercial"||
        this.typeAds == "realEstate"
      ) {
        locationIdForCardAds = 6;
      }
      if (
        (this.$router.history.current.path == "/th" ||
          this.$router.history.current.path == "/en") &&
        this.typeAds == "land"||
        this.typeAds == "carsEngines"
      ) {
        locationIdForCardAds = 7;
      }
      if (
        (this.$router.history.current.path == "/th" ||
          this.$router.history.current.path == "/en") &&
        this.typeAds == "newProject"||
        this.typeAds == "findJob"
      ) {
        locationIdForCardAds = 8;
      }
  
      if (this.$router.history.current.name == "SearchGrid"
      ) {
        locationIdForCardAds = 11;
      }
      // if (
      //   (this.$router.history.current.name == "SearchGrid") &&
      //     this.typeAds == "realEstate"
      // ) {
      //   locationIdForCardAds = 11;
      // }
      // if (
      //   (this.$router.history.current.name == "SearchGrid") &&
      //     this.typeAds == "carsEngines"
      // ) {
      //   locationIdForCardAds = 11;
      // }
      // if (
      //   (this.$router.history.current.name == "SearchGrid") &&
      //     this.typeAds == "findJob"
      // ) {
      //   locationIdForCardAds = 11;
      // }
      if (
        this.$router.history.current.name == "ListingDetail" &&
        this.typeAds == "residential"||
        this.typeAds == "marketPlace"
      ) {
        locationIdForCardAds = 17;
      }
      if (
        this.$router.history.current.name == "ListingDetail" &&
        this.typeAds == "commercial"||
        this.typeAds == "realEstate"
      ) {
        locationIdForCardAds = 26;
      }
      if (
        this.$router.history.current.name == "ListingDetail" &&
        this.typeAds == "land"||
        this.typeAds == "carsEngines"
      ) {
        locationIdForCardAds = 35;
      }
      if (
        this.$router.history.current.name == "ListingDetail" &&
        this.typeAds == "newProject"||
        this.typeAds == "findJob"
      ) {
        locationIdForCardAds = 44;
      };
      if (
        this.locationIdForCardAds != locationIdForCardAds &&
        this.showGoogleAds
      ) {
        this.locationIdForCardAds = locationIdForCardAds;
        this.getAds(locationIdForCardAds);
      }
    }
  },
  computed: {
    ...mapGetters("CategoryController", ["dataSearch"]),
    labelOrQueryParam() {
      return this.hasOwnProperty("label") ? this.label : this.queryParam;
    },
    
  }
};
</script>
<style lang="scss">
@import "style";
</style>